import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import { useToastMessage } from './hooks';
import { isFunction } from 'mojito/utils';

const { dispatch } = MojitoCore.Services.redux.store;
const ToastView = MojitoPresentation.Components.ToastView;
const { actions: messagingActions } = MojitoServices.Messaging;

const processMessage = message => dispatch(messagingActions.messageProcessed(message));

const ToastMessageController = props => {
    const { config } = props.mojitoTools;
    const toastMessage = useToastMessage(props.toastMessageType);

    const onClick = message => {
        const action = config.action;
        isFunction(action) && action(message);
        processMessage(message);
    };

    return (
        !!toastMessage && (
            <ToastView
                config={config.view}
                message={toastMessage}
                onClick={onClick}
                onClose={processMessage}
            />
        )
    );
};

export default ToastMessageController;
